export const environment = {
  production: false,
  url: "https://bbeatz-api-app-staging.stacknize.com/bbeatz/",
  url2: "https://bbeatz-api-app-staging.stacknize.com/notify/",
  preprod:false,
};

